(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gw-hero"] && !Shopify.designMode) return;
  try {
    
  const gwRunHero = () => {
    document.querySelectorAll('[data-gw-hero]').forEach((hero) => {
      const track = hero.querySelector('.gw-hero__track');
      const dots = [...hero.querySelectorAll('.gw-hero__dot')];
      if (!track || dots.length < 2) return;

      const current = () => Math.round(track.scrollLeft / track.clientWidth);
      const go = (i) => track.scrollTo({ left: i * track.clientWidth });
      const sync = () => dots.forEach((d, i) => d.setAttribute('aria-current', String(i === current())));

      dots.forEach((dot) => dot.addEventListener('click', () => go(Number(dot.dataset.index))));
      track.addEventListener('scroll', () => requestAnimationFrame(sync), { passive: true });

      const seconds = Number(hero.dataset.autoplay);
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!seconds || reduce || window.Shopify?.designMode) return;

      let paused = false;
      ['mouseenter', 'focusin', 'touchstart'].forEach((e) => hero.addEventListener(e, () => (paused = true), { passive: true }));
      ['mouseleave', 'focusout'].forEach((e) => hero.addEventListener(e, () => (paused = false)));
      setInterval(() => {
        if (!paused && !document.hidden) go((current() + 1) % dots.length);
      }, seconds * 1000);
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', gwRunHero);
  } else {
    gwRunHero();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gw-main-product"]) return;
  try {
    
  const gwInitProduct = () => document.querySelectorAll('[data-gw-product]:not([data-gw-ready])').forEach((root) => {
    root.dataset.gwReady = '';
    const variants = JSON.parse(root.querySelector('[data-gw-variants]').textContent);
    const form = root.querySelector('[data-gw-form]');
    const idInput = root.querySelector('[data-gw-variant-id]');
    const slides = root.querySelector('[data-gw-slides]');
    const thumbs = [...root.querySelectorAll('[data-gw-thumb]')];
    const sticky = root.querySelector('[data-gw-sticky]');
    const scope = (sel) => [...root.querySelectorAll(sel), ...(sticky ? sticky.querySelectorAll(sel) : [])];

    const slideIndex = () => (slides ? Math.round(slides.scrollLeft / slides.clientWidth) : 0);
    const showSlide = (i) => {
      if (!slides) return;
      const n = slides.children.length;
      slides.scrollTo({ left: ((i + n) % n) * slides.clientWidth });
    };
    const showMedia = (mediaId) => {
      const target = slides?.querySelector(`[data-media-id="${mediaId}"]`);
      if (target) showSlide([...slides.children].indexOf(target));
    };
    root.querySelector('[data-gw-prev]')?.addEventListener('click', () => showSlide(slideIndex() - 1));
    root.querySelector('[data-gw-next]')?.addEventListener('click', () => showSlide(slideIndex() + 1));
    thumbs.forEach((t) => t.addEventListener('click', () => showMedia(t.dataset.gwThumb)));
    slides?.addEventListener(
      'scroll',
      () =>
        requestAnimationFrame(() => {
          const current = slides.children[slideIndex()]?.dataset.mediaId;
          thumbs.forEach((t) => t.setAttribute('aria-current', String(t.dataset.gwThumb === current)));
        }),
      { passive: true }
    );

    const update = () => {
      const selected = [];
      root.querySelectorAll('input[data-option-index]:checked').forEach((input) => {
        selected[Number(input.dataset.optionIndex)] = input.value;
        const label = root.querySelector(`[data-gw-selected="${input.dataset.optionIndex}"]`);
        if (label) label.textContent = input.value;
      });
      const variant = variants.find((v) => v.options.every((o, i) => o === selected[i]));
      const buttons = scope('[data-gw-atc]');
      if (!variant) {
        buttons.forEach((b) => (b.disabled = true));
        return;
      }
      idInput.value = variant.id;
      buttons.forEach((b) => (b.disabled = !variant.available));
      scope('[data-gw-atc-label]').forEach((l) => {
        l.textContent = variant.available ? root.dataset.labelAdd : root.dataset.labelSold;
      });
      const sv = sticky?.querySelector('[data-gw-sticky-variant]');
      if (sv) sv.textContent = variant.title;
      const sp = sticky?.querySelector('[data-gw-sticky-price]');
      if (sp) sp.textContent = variant.price;
      const sc = sticky?.querySelector('[data-gw-sticky-compare]');
      if (sc) {
        sc.hidden = !variant.compare;
        sc.textContent = variant.compare || '';
      }
      if (variant.media) showMedia(variant.media);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState(history.state, '', url);
    };
    form?.addEventListener('change', (e) => {
      if (e.target.matches('input[data-option-index]')) update();
      if (e.target.matches('input[data-gw-bundle]')) {
        root.querySelector('[data-gw-bundle-qty]').value = e.target.value;
        const sp = sticky?.querySelector('[data-gw-sticky-price]');
        if (sp) sp.textContent = e.target.dataset.price;
        const sc = sticky?.querySelector('[data-gw-sticky-compare]');
        if (sc) sc.textContent = e.target.dataset.mrp;
        const sv = sticky?.querySelector('[data-gw-sticky-variant]');
        if (sv) sv.textContent = e.target.value === '1' ? '' : `Pack of ${e.target.value}`;
      }
    });

    if (sticky) {
      sticky.style.setProperty('--gw-accent', getComputedStyle(root).getPropertyValue('--gw-accent'));
      document.body.appendChild(sticky);
      const main = form.querySelector('[data-gw-atc]');
      const mobile = window.matchMedia('(max-width: 749px)');
      let queued = false;
      const check = () => {
        queued = false;
        const r = main.getBoundingClientRect();
        const inView = r.bottom > 0 && r.top < window.innerHeight;
        const show = !inView && (mobile.matches || r.top < 0);
        sticky.classList.toggle('is-visible', show);
        sticky.toggleAttribute('inert', !show);
        sticky.setAttribute('aria-hidden', String(!show));
      };
      const queue = () => {
        if (!queued) {
          queued = true;
          requestAnimationFrame(check);
        }
      };
      document.addEventListener('scroll', queue, { capture: true, passive: true });
      window.addEventListener('resize', queue);
      check();
    }
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', gwInitProduct);
  } else {
    gwInitProduct();
  }
  document.addEventListener('shopify:section:load', gwInitProduct);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gw-pdp-usecases"] && !Shopify.designMode) return;
  try {
    
  const gwRunUseCases = () => {
    document.querySelectorAll('.gw-uc__track').forEach((track) => {
      if (track.children.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      let paused = false;
      track.addEventListener('pointerenter', () => (paused = true));
      track.addEventListener('pointerleave', () => (paused = false));
      setInterval(() => {
        if (paused || document.hidden) return;
        const i = Math.round(track.scrollLeft / track.clientWidth);
        track.scrollTo({ left: ((i + 1) % track.children.length) * track.clientWidth, behavior: 'smooth' });
      }, 4000);
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', gwRunUseCases);
  } else {
    gwRunUseCases();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gw-reviews"] && !Shopify.designMode) return;
  try {
    
  const gwRunReviews = () => {
    document.querySelectorAll('.gw-rev').forEach((root) => {
      const list = root.querySelector('[data-gw-reviews]');
      const per = Number(list.dataset.perPage);
      root.querySelectorAll('[data-gw-page]').forEach((btn) =>
        btn.addEventListener('click', () => {
          const page = Number(btn.dataset.gwPage);
          [...list.children].forEach((li, i) => (li.hidden = i < (page - 1) * per || i >= page * per));
          root.querySelectorAll('[data-gw-page]').forEach((b) => b.removeAttribute('aria-current'));
          btn.setAttribute('aria-current', 'page');
        })
      );
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', gwRunReviews);
  } else {
    gwRunReviews();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
